import { Component, OnInit, Inject, ViewChild, TemplateRef, ComponentFactoryResolver, ViewContainerRef, ComponentRef, OnDestroy, OnChanges } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-pop-up',
  templateUrl: './pop-up.component.html',
  styleUrls: ['./pop-up.component.scss']
})
export class PopUpComponent implements OnInit, OnDestroy {
  @ViewChild('FormComponent', { read: ViewContainerRef, static: true }) vcRef: ViewContainerRef;
  public componentRef: ComponentRef<any>;
  public formComponent: any;
  public title = 'Form';
  public submitButtonLabel = 'Submit';
  public cancelButtonLabel = 'Cancel';

  constructor(
    public dialogRef: MatDialogRef<PopUpComponent>,
    private resolver: ComponentFactoryResolver,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }
  
  ngOnInit(): void {
    const factory = this.resolver.resolveComponentFactory(this.data.component);
    this.vcRef.clear();
    this.componentRef = this.vcRef.createComponent(factory);
    this.formComponent = this.componentRef.instance;
    this.formComponent.selectedMasterData = this.data.records.selectedItem;
    this.formComponent.masterList = this.data.records.uniqueItemList;
    this.formComponent.submitButtonLabel = this.data.buttonLabel;
    this.formComponent.fetchDataOnCloseDialog$.subscribe(data => {
      if (data.length > 0) {
        this.closeDialog(data);
      }
    })
  }

  closeDialog(item: any) {
    this.dialogRef.close(item);
  }

  ngOnDestroy(): void {
    if (this.componentRef) {
      this.componentRef.destroy();
    }
  }

}
